<template>
  <img src="/images/shoulder.png">
</template>

<script>
  export default {
    name: "Shoulder",
  }
</script>
